import * as React from "react"
import { SVGProps } from "react"
const LargeArrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={12}
    fill="none"
    {...props}
  >
    <path fill="#fff" d="M0 6.751V5.202h15.63v1.55z" />
    <path
      fill="#fff"
      d="M1.55 10.563H0V5.202h1.55zM10.428 11.955 9.333 10.86l5.203-5.203 1.095 1.095z"
    />
    <path fill="#fff" d="M9.333 1.095 10.428 0l5.203 5.202-1.095 1.096z" />
  </svg>
)
export default LargeArrowRight
